import { Link } from "react-router-dom";

const POINTS = [
  {
    icon: "ri-database-2-line",
    title: "资料完整对应",
    desc: "列表卡片与详情页的电影标题、封面、年份、简介保持一致，不拼凑信息。",
  },
  {
    icon: "ri-focus-3-line",
    title: "高清修复单元",
    desc: "以修复版画质与版本说明为重点，帮助影迷区分不同发行版本。",
  },
  {
    icon: "ri-route-line",
    title: "清晰的浏览路径",
    desc: "分类筛选、站内搜索与相关推荐互相打通，找片不再靠翻页。",
  },
];

export default function AboutSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <p className="font-label text-[11px] font-medium uppercase tracking-[0.24em] text-accent-600">
              About the Site
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[28px]">
              关于本站
            </h2>
            <p className="mt-4 text-sm leading-[1.9] text-foreground-600">
              色戒完整版无删减hd 是一个以高清影视内容展示与影视资讯整理为核心的门户站点。我们把影片的基础资料、
              剧情脉络与主创信息放在同一个页面里，让影迷在观看前能够快速建立对影片的整体认知。
            </p>
            <p className="mt-3 text-sm leading-[1.9] text-foreground-600">
              站点内容以资料整理与介绍为主，所有影片信息、资讯文章均为演示内容，不提供在线播放、下载或任何形式的版权内容分发。
              如果你发现资料有误，欢迎通过页脚的联系方式告诉我们。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                开始浏览影片
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/news"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
              >
                看看影视资讯
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              {POINTS.map((point, index) => (
                <div
                  key={point.title}
                  className={`rounded-lg border p-5 ${
                    index === 0
                      ? "border-accent-200 bg-accent-50"
                      : "border-background-200 bg-background-100"
                  }`}
                >
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-md ${
                      index === 0
                        ? "bg-accent-500 text-background-50"
                        : "bg-background-50 text-primary-600"
                    }`}
                  >
                    <i className={`${point.icon} text-[20px]`} />
                  </span>
                  <h3 className="mt-4 font-heading text-sm font-semibold text-foreground-950">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{point.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {[
                { value: "18", label: "影片条目" },
                { value: "12", label: "资讯文章" },
                { value: "6", label: "影片类型" },
                { value: "100%", label: "资料对应" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200 bg-background-50 px-3 py-4 text-center"
                >
                  <p className="font-label text-lg font-bold text-primary-600">{stat.value}</p>
                  <p className="mt-0.5 text-[11px] text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}